<template>
  <ion-content fullscreen>
    <ion-grid>
      <ion-row>
        <ion-col
          size="10"
          offset="1"
          size-sm="10"
          offset-sm="1"
          size-md="8"
          offset-md="2"
          size-lg="6"
          offset-lg="3"
          size-xl="4"
          offset-xl="4"
        >
          <h2 class="logo">
            Maak een gratis tonytalks account
          </h2>
          <p>
            Tonytalks is een gratis en eenvoudige te gebruiken communicatie app.
          </p>
        </ion-col>
      </ion-row>

      <form @submit.prevent="processForm">
        <ion-row class="ion-padding-top">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-list lines="full" class="ion-no-margin ion-no-padding">
              <!-- <ion-item>
                <ion-label position="floating"
                  >Naam
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input required type="text" @input="name = $event.target.value"></ion-input>
              </ion-item> -->

              <ion-item>
                <ion-label position="floating"
                  >E-mailadres
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input required type="email" @input="email = $event.target.value"></ion-input>
              </ion-item>

              <ion-item>
                <ion-label position="floating"
                  >Wachtwoord
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input
                  required
                  type="password"
                  @input="password = $event.target.value"
                ></ion-input>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row class="ion-padding-top">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button expand="block" color="primary" type="submit" class="ion-no-margin"
              >Account aanmaken
            </ion-button>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button expand="block" color="light" class="ion-no-margin" href="/login"
              >Heb je al een account? <ion-anchor>&nbsp;Log in</ion-anchor></ion-button
            >
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
  </ion-content>
</template>
<style lang="scss" scoped>
ion-item {
  --padding-start: 0;
}
.logo {
  font-family: "Eina", sans-serif;
  color: rgb(15, 22, 32);
  text-align: center;
  margin-top: 10vh;
  font-size: 24px;
  font-weight: 500;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}
p {
  font-family: "Eina", sans-serif;
  color: rgb(59, 67, 77);
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}
</style>
<script>
import * as firebase from "firebase/app";

export default {
  name: "signup",
  components: {},
  data() {
    return {
      email: "",
      password: "",
      errorMsg: ""
    };
  },
  methods: {
    presentAlert(error) {
      return this.$ionic.alertController
        .create({
          header: "Error",
          message: this.errorMsg,
          buttons: ["OK"]
        })
        .then(a => a.present());
    },
    processForm() {
      if (this.email.length < 4) {
        this.errorMsg = "Vul een geldig e-mailadres in.";
        this.presentAlert();
        return;
      }
      if (this.password.length < 4) {
        this.errorMsg = "Vul een geldig wachtwoord in.";
        this.presentAlert();
        return;
      }
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.replace("dashboard");
          },
          error => {
            let errorCode = error.code;
            if (errorCode == "auth/weak-password") {
              this.errorMsg = "Het wachtwoord is te zwak.";
              this.presentAlert();
            } else if (errorCode == "auth/email-already-in-use") {
              this.errorMsg = "Er bestaat al een account met dit e-mailadres.";
              this.presentAlert();
            } else {
              console.log(error);
            }
          }
        );
    },
    sendEmailVerification() {
      firebase
        .auth()
        .currentUser.sendEmailVerification()
        .then(function() {
          console.log("Email Verification Sent!");
        });
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          // Sign-out successful.
          console.log("Logged out");
        })
        .catch(function(error) {
          // An error happened.
          console.log("Logging out error: " + error);
        });
    },
    created() {}
  }
};
</script>
